import React, { memo } from 'react';

//SCSS
import classes from './HeroGraphic.module.scss'

const HeroGraphic = (props) =>{

    return (
        <div className={classes.HeroGraphic}>
            {props.heroGraphicIcon}
            <p className={classes.HeroGraphic__smallTitle}>{props.heroGraphicSmallTitle}</p>
            <div className={`divider`}></div>
            <h1 className={classes.HeroGraphic__title}>{props.heroGraphicTitle}</h1>
        </div>
    )
}

export default memo( HeroGraphic )
